module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceAnimatedMenuRenderModule",
    "path": "front/piece-animated-menu-render.module"
  },
  "cms-module": {
    "name": "PieceAnimatedMenuCmsModule",
    "path": "front/piece-animated-menu-cms.module"
  },
  "definition": {
    "type": "animated-menu",
    "name": "PieceAnimatedMenuDefinition",
    "group": "Components",
    "availablePlatforms": ["web"],
    "description": "Menú animado",

    "fields": [
      { "name": "menuAnimatedItems", "label": "Menú", "type": "menuAnimatedItems" },
      {
        "label": "Avanzado",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          {
            "name": "theme",
            "type": "optionsSelect",
            "label": "Tema",
            "defaultValue": "light",
            "values": [
              {
                "label": "Claro",
                "value": "light"
              },
              {
                "label": "Oscuro",
                "value": "dark"
              },
              {
                "label": "Blend",
                "value": "blend"
              }
            ]
          },
          {
            "name": "transitionEffects",
            "type": "options",
            "label": "Efecto de transición",
            "defaultValue": "none",
            "values": [
              {
                "label": "Por defecto",
                "value": "none"
              }
            ]
          }
        ]
      }
    ]
  }
};
